import { render, staticRenderFns } from "./resourcePreview.vue?vue&type=template&id=93252f60&scoped=true"
import script from "./resourcePreview.vue?vue&type=script&lang=js"
export * from "./resourcePreview.vue?vue&type=script&lang=js"
import style0 from "./resourcePreview.vue?vue&type=style&index=0&id=93252f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93252f60",
  null
  
)

export default component.exports